import './notification.css';

/**
 * Bootstrap 5 notification banner (Alpine component: 'kibeNotifications').
 *
 * The alerts are rendered server-side by NotificationViewController; this component only:
 *  - removes alerts the user already dismissed (cookie), on init,
 *  - persists a dismissal in a cookie and removes the alert on click,
 *  - keeps the legacy layout offset (#main / #header / #sidebar) in sync with the banner height.
 *
 * Cookie name/value/path mirror the legacy notifications.js so a dismissal is shared between the
 * two implementations (the login page still uses the legacy banner).
 */

const COOKIE_PREFIX = 'NotificationHide_';
const COOKIE_VALUE = 'hidden';
const COOKIE_EXPIRE_DAYS = 1;

export default () => ({
    init() {
        // Drop notifications already dismissed in a previous visit, then size the layout offset.
        this.$el.querySelectorAll('.kibe-notification').forEach(el => {
            if (isHidden(el.dataset.uniqid)) {
                el.remove();
            }
        });
        this.$nextTick(() => updateContentOffset());
        this._onResize = () => updateContentOffset();
        window.addEventListener('resize', this._onResize);
    },

    destroy() {
        window.removeEventListener('resize', this._onResize);
    },

    dismiss(el) {
        if (!el) return;
        setHiddenCookie(el.dataset.uniqid);
        el.remove();
        updateContentOffset();
    }
});

function isHidden(uniqid) {
    return getCookie(COOKIE_PREFIX + uniqid) === COOKIE_VALUE;
}

function setHiddenCookie(uniqid) {
    const expires = new Date();
    expires.setTime(expires.getTime() + COOKIE_EXPIRE_DAYS * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE_PREFIX + uniqid + '=' + COOKIE_VALUE
        + ';expires=' + expires.toUTCString()
        + ';path=' + firstPartURL()
        + ';secure';
}

function getCookie(name) {
    const match = document.cookie.split('; ').find(c => c.startsWith(name + '='));
    return match ? match.split('=')[1] : null;
}

/** Context path: https://host/jupiter_dev/Be/Overview.do -> /jupiter_dev (mirrors notifications.js). */
function firstPartURL() {
    const parts = window.location.pathname.split('/');
    return '/' + (parts[1] || '');
}

/** Pushes the page content below the fixed banner, based on its current height. */
function updateContentOffset() {
    const container = document.getElementById('kibenotificationGlobal');
    const height = container ? container.offsetHeight : 0;
    const main = document.getElementById('main');
    const header = document.getElementById('header');
    const sidebar = document.getElementById('sidebar');
    if (main) main.style.paddingTop = height + 'px';
    if (header) header.style.top = height + 'px';
    if (sidebar) sidebar.style.paddingTop = (height + 40) + 'px';
}
